/**
 * payrollDateUtils.js
 * -------------------
 * Reusable date, month, and year utilities for Payroll modules
 * (Daily Attendance, Monthly Attendance, Salary Process, etc.).
 *
 * Consolidates duplicated month/year arrays, label resolvers, and
 * standard processing tools across all payroll features.
 */

export const MONTH_OPTIONS = [
  { value: 1, label: 'January' },
  { value: 2, label: 'February' },
  { value: 3, label: 'March' },
  { value: 4, label: 'April' },
  { value: 5, label: 'May' },
  { value: 6, label: 'June' },
  { value: 7, label: 'July' },
  { value: 8, label: 'August' },
  { value: 9, label: 'September' },
  { value: 10, label: 'October' },
  { value: 11, label: 'November' },
  { value: 12, label: 'December' },
];

export const YEAR_OPTIONS = (() => {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: 6 }, (_, i) => ({
    value: currentYear - 2 + i,
    label: String(currentYear - 2 + i),
  }));
})();

export const GENDER_OPTIONS = [
  { value: 'All', label: 'All Genders' },
  { value: 'M', label: 'Male' },
  { value: 'F', label: 'Female' },
];

export const STATUS_OPTIONS = [
  { value: 'All', label: 'All Status' },
  { value: 'Processed', label: 'Processed' },
  { value: 'Pending', label: 'Pending' },
];

export const STANDARD_PAYROLL_TOOLS = [
  { key: 'print', label: 'Print Report', icon: 'print' },
  { key: 'export_excel', label: 'Export Excel', icon: 'description' },
  { key: 'export_pdf', label: 'Export PDF', icon: 'picture_as_pdf' },
  { key: 'rollback', label: 'Rollback Process', icon: 'history', danger: true },
];

/**
 * Returns the full English name for a month (1-12).
 */
export function getMonthName(monthNumber) {
  const num = Number(monthNumber);
  const found = MONTH_OPTIONS.find((m) => m.value === num);
  return found ? found.label : '';
}

/**
 * Formats a month and year into a standard human-readable string (e.g. "September 2026").
 */
export function formatMonthYear(month, year) {
  const name = getMonthName(month);
  return name ? `${name} ${year}` : `${year}`;
}
